/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable import/named */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { withScope, captureException } from '@sentry/react';
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import { EMPTY, from, iif, interval, merge, of, Subject, timer } from 'rxjs';
import {
  buffer,
  catchError,
  delay,
  distinctUntilChanged,
  filter,
  ignoreElements,
  map,
  mapTo,
  mergeMap,
  share,
  skipUntil,
  switchMap,
  take,
  takeUntil,
} from 'rxjs/operators';
import { webSocket } from 'rxjs/webSocket';

import { getAccountLeverage } from 'actions/account';
import { getOrderLeverage } from 'actions/orderbook';
import { getSettings } from 'actions/settings';
import {
  getOpenOrdersFromApi,
  getOpenStopOrdersFromApi,
  getOptionsInfo,
  getPositionsFromApi,
  getProductList,
  getSpotIndices,
} from 'actions/trade';
import {
  getKycStatus,
  isAuthenticated,
  setAuthSocketChannelStatus,
  setUnauthorized,
} from 'actions/user';
import { getBalances, getConversionConfig } from 'actions/wallet';
import { LoginViaBiometricsActionTypes, LoginViaQrActionTypes } from 'actionTypes/auth';
import { TAB_INACTIVE, TAB_REACTIVE } from 'actionTypes/other';
import {
  AUTHENTICATE_SOCKET,
  CHECK_HEARTBEAT,
  CONNECT_SELECTED_PRODUCT_CHANNEL,
  CONNECT_SOCKET,
  DISABLE_HEARTBEAT,
  DISCONNECT_SOCKET,
  ENABLE_HEARTBEAT,
  SOCKET_CONNECTED,
  SUBSCRIBE_CONTRACT_ALL_RECENT_TRADES,
  SUBSCRIBE_FUNDING,
  SUBSCRIBE_MARGIN,
  SUBSCRIBE_OHLC_CANDEL,
  SUBSCRIBE_ORDERS,
  SUBSCRIBE_PUBLIC_CHANNELS,
  SUBSCRIBE_TICKER,
  SUBSCRIBE_TRADING_NOTIFICATIONS,
  UNSUBSCRIBE_ALL,
  UNSUBSCRIBE_CONTRACT_ALL_RECENT_TRADES,
  UNSUBSCRIBE_FUNDING,
  UNSUBSCRIBE_OHLC_CANDEL,
  UNSUBSCRIBE_PRIVATE,
  UNSUBSCRIBE_TICKER,
  SUBSCRIBE_POSITION_TICKER,
  UNSUBSCRIBE_POSITION_TICKER,
  AUTH_CHANNEL_RETRY,
} from 'actionTypes/socket';
import TRADE from 'actionTypes/trade';
import { getSubscriptionValue } from 'components/chart/helper';
import { AUTH_CHANNEL_STATUS } from 'constants/authChannel';
import {
  ASSET_SYMBOL,
  ENABLED_WALLETS,
  MARGIN_CHANNELS_MAP,
  SOCKET_CONNECTION_TIMEOUT,
  SOCKET_RECONNECTION_DELAY,
  SOCKET_URL,
  TAB_INACTIVE_DELAY,
  VANILLA_SETTLING_ASSET,
} from 'constants/constants';
import { MARGIN_MODE } from 'constants/enums';
import { devOnlyErrorLogger } from 'helpers/logger';
import {
  contains,
  flatten,
  forEach,
  pipe,
  map as Rmap,
  of as Rof,
  values,
} from 'helpers/ramda';
import { addLogsToSentry } from 'helpers/sentry';
import { isAuthTokenExpired } from 'helpers/user';
import { isEmpty, noop } from 'helpers/utils';
import { isNotEmpty, isTruthy } from 'ramdax';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { userSelector } from 'selectors/otherSelectors';
import { socketActiveSelector } from 'selectors/socketSelectors';
import { updateAllTickers } from 'stores/store.globalActions/24hrTicker';
import { updateHeartbeatTS } from 'stores/store.globalActions/app';
import { updateSelectedProductFundingData } from 'stores/store.globalActions/selectedProduct';
import { updateTradingViewData } from 'stores/store.globalActions/tradingView';
import { ContractType } from 'types/IProducts';
import IState, { CustomAction } from 'types/Istore';

import {
  authenticateSocket,
  checkHeartbeat,
  connectSelectedProductChannels,
  connectSocket,
  disconnectSocket,
  enableHeartbeat,
  socketConnected,
  subscribeFunding,
  subscribeMarginChannels,
  subscribeOrders,
  subscribePublicChannels,
  subscribeSelectedProductMarkData,
  subscribeSelecteProductSpot,
  subscribeSpot,
  subscribeTradingNotifications,
  subscribeWalletSpot,
  unsubscribeAll,
  unsubscribeFunding,
  unsubscribeMark,
  unsubscribeSelecteProductSpot,
} from '../actions/socket';
import USER, { NATIVE_USER_DATA, UNAUTHORIZED } from '../actionTypes/user';
import { allOpenPositionsSelector } from '../selectors/holdingsSelectors';
import { heartbeatTSSelector } from '../selectors/priceSelectors';
import {
  isOnlineSelector,
  previousSelectedProductSelector,
  selectedProductState,
} from '../selectors/tradeSelectors';
import { notificationsActionsMap } from './notifications';
import { orderActionsMap } from './orderActions';
import { getTradePageActions, getTransactionPageAction } from './trade';

let onOpenSubject = new Subject();
let onCloseSubject = new Subject();

const createWebSocketSubject = () => {
  onOpenSubject = new Subject();
  onCloseSubject = new Subject();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  wsSubject = webSocket({
    url: SOCKET_URL,
    openObserver: onOpenSubject,
    closeObserver: onCloseSubject,
  });
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return wsSubject;
};

// eslint-disable-next-line no-var
export var wsSubject = createWebSocketSubject();

export const connectEpic = (action$: CustomAction, state$: StateObservable<IState>) =>
  action$.pipe(
    ofType(CONNECT_SOCKET),
    filter(() => {
      const socketActive = socketActiveSelector(state$.value);
      return socketActive === false || socketActive === null; // try connection only if socket connection is inactive
    }),
    /** Check why this is needed and also change this line 205 createWebSocketSubject function call to wsSubject */
    switchMap(() =>
      createWebSocketSubject().pipe(
        map(() => {}), // connects to socket and map messages
        catchError(e => {
          console.error('DEBUG , error in socket connection', e, e.type);
          return EMPTY;
          // cannot disconnect socket on errors here . Handling is done by heartbeart or ping pong
          // return of({ type: DISCONNECT_SOCKET, payload: { retry: true } });
        })
      )
    )
  );

export const connectedEpic = (action$: CustomAction, state$: StateObservable<IState>) =>
  action$.pipe(
    ofType(CONNECT_SOCKET),
    filter(() => {
      const socketActive = socketActiveSelector(state$.value);
      return socketActive === false || socketActive === null;
    }),
    switchMap(() =>
      onOpenSubject.pipe(
        map(() => {
          return { type: SOCKET_CONNECTED, payload: true };
        })
      )
    ),
    catchError(err => {
      console.error('DEBUG disconnection epic', err);
      return EMPTY;
    })
  );

export const verifySocketConnectionEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(CONNECT_SOCKET),
    switchMap(() => {
      return timer(SOCKET_RECONNECTION_DELAY).pipe(
        map(() => {
          const socketActive = socketActiveSelector(state$.value);
          if (socketActive) {
            return noop;
          }
          return disconnectSocket({ retry: true });
        }),
        takeUntil(action$.ofType(DISCONNECT_SOCKET, ENABLE_HEARTBEAT))
      );
    })
  );

export const closeWebsocketConnectionEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(DISCONNECT_SOCKET),
    mergeMap(action => {
      onCloseSubject.complete();
      wsSubject.complete();
      if (action.payload.retry === true) {
        return of(socketConnected(false), unsubscribeAll(), connectSocket());
      }
      return of(socketConnected(false), unsubscribeAll());
    }),
    catchError(err => {
      console.error('DEBUG close socket connection', err);
      return EMPTY;
    })
  );

export const initialiseSocketSubscriptionEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SOCKET_CONNECTED),
    map(() => socketActiveSelector(state$.value)),
    distinctUntilChanged(),
    filter(value => value === true),
    mergeMap(() => {
      return of(
        enableHeartbeat({}),
        subscribePublicChannels({}),
        connectSelectedProductChannels({}),
        authenticateSocket({}),
        checkHeartbeat({})
      );
    }),
    catchError(err => {
      console.error('DEBUG', err);
      return EMPTY;
    })
  );

// this epic looks exactly like selectedProductEpic but this only runs on reconnection and selectedProductEpic runs on contract switching
// cant mix both as distinctUntilChanged will not work in case connectSelectedProductEpic
export const connectSelectedProductEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(CONNECT_SELECTED_PRODUCT_CHANNEL),
    map(() => selectedProductState(state$.value)),
    filter(isTruthy),
    mergeMap(product => {
      const { symbol, contract_type, id } = product;

      const actions = [];

      if (contract_type === ContractType.InterestRateSwaps) {
        actions.push(subscribeSpot());
      }

      const previousSelectedProduct = previousSelectedProductSelector(state$.value);
      const enabledSpotWalletIndices = enabledWalletSpotSymbols();

      const allPositions = allOpenPositionsSelector(state$.value);
      const hasPosition = allPositions.reduce(
        (acc, position) =>
          position.product?.symbol === previousSelectedProduct?.symbol
            ? acc || true
            : acc || false,
        false
      );
      const isDesktop = typeof window === 'object' && window?.innerWidth >= 1024;
      const activeTab = state$?.value?.appDrawer?.activeTab;
      const isPortfolioTabMobile =
        !isDesktop && activeTab === APP_DRAWER_TAB_ID_MAPPING.POSITIONS;

      if (
        previousSelectedProduct?.spot_index?.symbol &&
        !enabledSpotWalletIndices.includes(
          previousSelectedProduct?.spot_index?.symbol && !hasPosition
        )
      ) {
        actions.push(
          unsubscribeSelecteProductSpot(previousSelectedProduct?.spot_index?.symbol)
        );
      }

      if (isNotEmpty(previousSelectedProduct) && !hasPosition) {
        actions.push(unsubscribeMark());
      }

      if (contract_type === ContractType.PerpetualFutures) {
        actions.push(unsubscribeFunding(), subscribeFunding(symbol));
      }

      if (contract_type !== 'spot') {
        if (isAuthenticated(state$.value.user)) {
          if (!isPortfolioTabMobile) {
            actions.push(getOrderLeverage(id));
          }
          actions.push(getAccountLeverage({ user_id: state$.value.user.id }));
        }

        actions.push(
          subscribeSelectedProductMarkData(symbol),
          subscribeSelecteProductSpot(product.spot_index.symbol)
        );
      }

      return from([...actions]).pipe(catchError(err => console.log('DEBUG:\n', err)));
    })
  );

// Subscribe to heartbeat. If no message is recieved within 35 seconds, reconnect.
const subscribeHeartbeatChannel = () => {
  return wsSubject.multiplex(
    () => ({
      type: 'enable_heartbeat',
    }),
    () => ({
      type: 'disable_heartbeat',
    }),
    message => true
  );
};

export const subscribeHeartbeatEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(ENABLE_HEARTBEAT),
    mergeMap(() =>
      subscribeHeartbeatChannel().pipe(
        takeUntil(action$.ofType(DISABLE_HEARTBEAT, UNSUBSCRIBE_ALL)),
        catchError((err, caught) => {
          console.error('HEARTBEAT', err);
          return EMPTY;
        })
      )
    ),
    map(updateHeartbeatTS),
    catchError(err => {
      console.error('DEBUG enable heartbeat :', err);
      // logToSentry(err);
      return EMPTY;
    })
  );

// Heartbeat check.
export const heartbeatCheck = (action$: CustomAction, state$: StateObservable<IState>) =>
  action$.pipe(
    ofType(CHECK_HEARTBEAT),
    delay(SOCKET_RECONNECTION_DELAY),
    map(() => heartbeatTSSelector()),
    map(hb => {
      return new Date().getTime() - hb <= SOCKET_CONNECTION_TIMEOUT;
    }),
    mergeMap(isOnTime => {
      if (!isOnTime && socketActiveSelector(state$.value)) {
        return of(
          socketConnected(false),
          unsubscribeAll(),
          disconnectSocket({ retry: true })
        );
      }
      return of(checkHeartbeat());
    })
  );

const getPublicChannelList = () => {
  return [
    {
      name: 'v2/product_updates',
    },
    { name: 'system_status' },
  ];
};

const publicChannel = () =>
  wsSubject.multiplex(
    () => ({
      type: 'subscribe',
      payload: {
        channels: getPublicChannelList(),
      },
    }),
    () => ({
      type: 'unsubscribe',
      payload: {
        channels: getPublicChannelList(),
      },
    }),
    message =>
      getPublicChannelList()
        .map(channel => channel.name)
        .includes(message.type)
  );

export const publicChannelEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_PUBLIC_CHANNELS),
    mergeMap(() =>
      publicChannel(state$.value).pipe(
        catchError(err => {
          console.error('Public', err);
          return EMPTY;
        }),
        takeUntil(action$.ofType(UNSUBSCRIBE_ALL))
      )
    ),
    map(message => dispatch => {
      // returning redux-thunk action
      const postActions = notificationsActionsMap[message.type];
      if (typeof postActions === 'function') {
        // postActions might return an array, hence flattening it later.
        pipe(
          () => postActions(message, state$.value),
          Rof, // [action1] || [[action2, action3]]
          flatten, // [action1, action2, action3]
          forEach(dispatch)
        )();
      }
    }),
    catchError(err => {
      // logToSentry(err);
      return EMPTY;
    })
  );

const tickerChannel = symbols =>
  wsSubject.multiplex(
    () => payloadGenerator('subscribe', 'v2/ticker', symbols),
    () => payloadGenerator('unsubscribe', 'v2/ticker', symbols),
    message => message.type === 'v2/ticker'
  );

export const subscribeTickerChannelEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SUBSCRIBE_TICKER),
    // map(() => productSymbolSelector(state$.value)),
    mergeMap(action => {
      const { payload } = action;
      return tickerChannel(payload).pipe(
        takeUntil(action$.ofType(UNSUBSCRIBE_TICKER, UNSUBSCRIBE_ALL)),
        buffer(intervalEvents),
        catchError(err => {
          console.log('Ticker', err);
          return EMPTY;
        })
      );
    }),
    filter(isNotEmpty),
    map(updateAllTickers),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    }),
    ignoreElements()
  );

export const subscribePositionTickerChannelEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SUBSCRIBE_POSITION_TICKER),
    mergeMap(action => {
      const { payload } = action;
      return tickerChannel(payload).pipe(
        takeUntil(
          action$.ofType(UNSUBSCRIBE_POSITION_TICKER, UNSUBSCRIBE_TICKER, UNSUBSCRIBE_ALL)
        ),
        buffer(intervalEvents),
        catchError(err => {
          console.error('PositionTicker', err);
          return EMPTY;
        })
      );
    }),
    filter(isNotEmpty),
    map(updateAllTickers),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    }),
    ignoreElements()
  );

export const productSymbolSelector = state => {
  const { products } = state.trade;
  return Rmap(product => product.symbol, values(products));
};

const intervalEvents = interval(1000);

export const payloadGenerator = (type, name, symbols) => {
  return {
    type,
    payload: {
      channels: [
        {
          name,
          symbols,
        },
      ],
    },
  };
};

// https://docs.delta.exchange/?shell#ohlc-candles
// Subscription payload sample { "name": "candlestick_1m", "symbols": ["BTCUSD_P"] }
/*
This channel provides ohlc updated for given time resolution Subscribe to ohlc_candle channel for updates

Subscription payload sample { "name": "candlestick_1m", "symbols": ["BTCUSD_P"] }

name = "candlestick_" + resolution resolutions = ["1m","3m","5m","15m","30m","1h","2h","4h","6h","12h","1d","1w","2w","30d"] symbols= product symbol

Sample response { "candle_start_time": 1596015240000000, "close": 9223, "high": 9228, "low": 9220, "open": 9221, "resolution": "1m", "symbol": "BTCUSD_P", "timestamp": 1596015289339699, "type": "candlestick_1m", "volume": 1.2 }

 */
const ohlcCandleChannelSubscribe = (symbol, type) => {
  // symbol: "BTCUSDT"
  // type: "candlestick_1w"
  let typeValue;

  if (type) {
    if (type.indexOf('H') > -1) {
      typeValue = type.replace(/H/g, 'h');
    } else if (type.indexOf('W') > -1) {
      typeValue = type.replace(/W/g, 'w');
    } else if (type.indexOf('D') > -1) {
      typeValue = type.replace(/D/g, 'd');
    } else {
      typeValue = type;
    }
  }
  const subscribeType = `candlestick_${typeValue}`;

  return wsSubject.multiplex(
    () => payloadGenerator('subscribe', subscribeType, [symbol]),
    () => {},
    message => message.type === subscribeType
  );
};

const unsubscribeOHLCCandle = (symbol, type) => {
  const typeValue = type.replace(/H/g, 'h');
  const subscribeType = `candlestick_${typeValue}`;
  return wsSubject.multiplex(
    () => payloadGenerator('unsubscribe', subscribeType, [symbol]),
    () => {},
    message => message.type === subscribeType
  );
};

export const unsubscribeOhlcCandleEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(UNSUBSCRIBE_OHLC_CANDEL),
    mergeMap(action => {
      const {
        payload: { subscribeUID },
      } = action;
      const [symbol, resolution] = [...new Set(subscribeUID.split('_#_'))]; // subscribeUID format is symbol_#_symbol_#_resolution
      const subscriptionValue = getSubscriptionValue(resolution);
      return unsubscribeOHLCCandle(symbol, subscriptionValue).pipe(
        catchError(_ => EMPTY)
      );
    })
  );

export const subscribeOHLCEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SUBSCRIBE_OHLC_CANDEL),
    mergeMap(action => {
      const currentResolution = action.payload.resolution;
      // ? JSON.parse(actio)
      // : { value: 60 };
      const resolution = getSubscriptionValue(currentResolution);

      const { symbol } = action.payload;
      const type = resolution;
      return ohlcCandleChannelSubscribe(symbol, type).pipe(catchError(_ => EMPTY));
    }),
    map(updateTradingViewData),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    })
  );
const allTradeChannel = symbols =>
  wsSubject.multiplex(
    () => payloadGenerator('subscribe', 'all_trades', symbols),
    () => payloadGenerator('unsubscribe', 'all_trades', symbols),
    message => message.type === 'all_trades' || message.type === 'all_trades_snapshot'
  );

export const subscribeContractAllRecentTradesEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) => {
  return action$.pipe(
    skipUntil(action$.ofType(SOCKET_CONNECTED)),
    filter(() => socketActiveSelector(state$.value)),
    ofType(SUBSCRIBE_CONTRACT_ALL_RECENT_TRADES),
    switchMap(action => {
      const { payload } = action;
      if (
        typeof payload !== 'object' ||
        !Array.isArray(payload.symbols) ||
        !payload.listener
      ) {
        return EMPTY;
      }
      const { symbols, listener } = payload;
      return allTradeChannel(symbols).pipe(
        takeUntil(
          action$.pipe(ofType(UNSUBSCRIBE_ALL, UNSUBSCRIBE_CONTRACT_ALL_RECENT_TRADES))
        ),
        catchError(err => {
          console.error('ALL TRADE CHANNEL', err);
          return EMPTY;
        }),
        map(message => {
          if ('next' in listener && typeof listener.next === 'function') {
            listener.next(message);
          } else if (typeof listener === 'function') {
            listener(message);
          }
        })
      );
    }),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    })
  );
};

const fundingChannel = symbol =>
  wsSubject.multiplex(
    () => payloadGenerator('subscribe', 'funding_rate', [symbol]),
    () => payloadGenerator('unsubscribe', 'funding_rate', [symbol]),
    message => message.type === 'funding_rate'
  );

export const subscribeFundingChannelEpic = (action$: CustomAction) =>
  action$.pipe(
    ofType(SUBSCRIBE_FUNDING),
    mergeMap(action =>
      fundingChannel(action.payload).pipe(
        takeUntil(action$.ofType(UNSUBSCRIBE_FUNDING, UNSUBSCRIBE_ALL)),
        catchError(err => {
          console.log('Funding', err);
          return EMPTY;
        })
      )
    ),
    filter(data => !isEmpty(data)),
    map(updateSelectedProductFundingData),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    }),
    ignoreElements()
  );

const authChannel = token =>
  wsSubject.multiplex(
    () => ({
      type: 'token-auth',
      payload: {
        token,
      },
    }),
    () => ({
      type: 'unauth',
    }),
    message => message.type === 'token-auth'
  );

export const tokenEpic = (action$: CustomAction, state$: StateObservable<IState>) => {
  let originalPayload = {};
  return action$.pipe(
    ofType(
      LoginViaQrActionTypes.SET_AUTHORIZED_USER,
      LoginViaBiometricsActionTypes.SET_AUTHORIZED_USER,
      USER.LOGIN.SUCCESS,
      AUTHENTICATE_SOCKET,
      USER.LOGINMFA.SUCCESS,
      USER.LOGIN_EMAIL_VERIFICATION.SUCCESS,
      NATIVE_USER_DATA
    ),
    mergeMap(({ type, payload }) => {
      if (type === AUTHENTICATE_SOCKET && payload) {
        originalPayload = payload;
      }

      const user = userSelector(state$.value);

      // Check if token is expired when authenticating socket
      if (type === AUTHENTICATE_SOCKET && isAuthTokenExpired(user)) {
        // Logout user if token is expired
        return of(setUnauthorized({}));
      }

      return of(user);
    }),
    filter(val => val && !val.type && val.token),
    map(user => user.token),
    switchMap(token => {
      const localFlag$ = iif(
        () => localStorage.getItem('manual_auth_block') === 'true',
        of({ type: 'manualSkip' }),
        authChannel(token)
      ).pipe(share()); // ? share is needed as its used in merge pipe & in takeuntil as well to prevent duplicate invocation

      // localFlag$(authchannel) observable will always stay active
      // cancel the timer as soon as localFlag$ emits
      return merge(
        localFlag$,
        timer(10_000).pipe(
          take(1),
          mapTo({ type: AUTH_CHANNEL_STATUS.TIMEOUT }),
          takeUntil(localFlag$)
        )
      ).pipe(
        takeUntil(
          action$.ofType(
            USER.LOGOUT.SUCCESS,
            UNAUTHORIZED,
            UNSUBSCRIBE_PRIVATE,
            UNSUBSCRIBE_ALL
          )
        ),
        catchError(err => {
          console.error('AUTH', err);
          return EMPTY;
        })
      );
    }),
    mergeMap(payload => {
      if (payload.success === true) {
        const actions = [
          setAuthSocketChannelStatus(AUTH_CHANNEL_STATUS.CONNECTED),
          subscribeOrders({}),
          subscribeTradingNotifications({}),
          subscribeWalletSpot({}),
          subscribeMarginChannels({}),
          getBalances({}),
        ];
        return from(actions);
      }
      // do nothing on bad auth token, retry authchannel or no internet
      if (
        originalPayload.retry ||
        payload.status_code === 404 ||
        !isOnlineSelector(state$.value)
      ) {
        return EMPTY;
      }

      console.log('degraded mode shown');
      const { user } = state$.value;
      const authSocketChannelStatus =
        payload.type === AUTH_CHANNEL_STATUS.TIMEOUT
          ? AUTH_CHANNEL_STATUS.TIMEOUT
          : AUTH_CHANNEL_STATUS.ERROR;

      addLogsToSentry(
        { ...user, authSocketChannelStatus }, // ? state hasnt updated yet for authSocketChannelStatus
        new Error(`Degraded mode enabled. Payload: ${JSON.stringify(payload)}`),
        undefined,
        {
          authSocketChannelStatus,
          authChannelStatusCode: payload.status_code || 0,
        }
      );

      return from([
        setAuthSocketChannelStatus(authSocketChannelStatus),
        { type: AUTH_CHANNEL_RETRY },
      ]);
    }),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    })
  );
};

const tradingNotificationsTypes = ['pnl', 'self_trade', 'auto_topup', 'v2/user_trades'];

const tradingNotificationsChannels = symbols => [
  {
    name: 'trading_notifications',
    symbols,
  },
  {
    name: 'v2/user_trades',
    symbols,
  },
];

const subscribeTradeNotification = () =>
  wsSubject.multiplex(
    () => ({
      type: 'subscribe',
      payload: {
        channels: tradingNotificationsChannels(['all']),
      },
    }),
    () => ({}),
    message => contains(message.type, tradingNotificationsTypes)
  );

export const subscribeTradingNotificationsEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_TRADING_NOTIFICATIONS),
    mergeMap(() => {
      return subscribeTradeNotification().pipe(
        takeUntil(action$.ofType(UNSUBSCRIBE_PRIVATE, UNSUBSCRIBE_ALL)),
        catchError(err => {
          console.error('TRADE NOTIFICATIONS', err);
          return EMPTY;
        })
      );
    }),
    map(message => dispatch => {
      // returning redux-thunk action
      const postActions = notificationsActionsMap[message.type];
      if (typeof postActions === 'function') {
        // postActions might return an array, hence flattening it later.
        pipe(
          () => postActions(message, state$.value),
          Rof, // [action1] || [[action2, action3]]
          flatten, // [action1, action2, action3]
          forEach(dispatch)
        )();
      }
    }),
    catchError(err => {
      logToSentry(err);
      return EMPTY;
    })
  );

const orderChannelNameList = [
  'positions',
  'margins',
  'orders',
  'portfolio_margins',
  'cross_margin',
  'multi_collateral',
  'user_product',
  'user_offers',
];

const privateDataChannelList = () => {
  return [
    {
      name: 'positions',
      symbols: ['all'],
    },
    {
      name: 'orders',
      symbols: ['all'],
    },
    {
      name: 'margins',
    },
    {
      name: 'user_product',
    },
    {
      name: 'user_offers',
    },
  ];
};

const marginChannel = marginMode => {
  const channels = MARGIN_CHANNELS_MAP[marginMode].map(channel => ({
    name: channel,
  }));
  return wsSubject.multiplex(
    () => ({
      type: 'subscribe',
      payload: {
        channels,
      },
    }),
    () => ({
      type: 'unsubscribe',
      payload: {
        channels,
      },
    }),
    message => MARGIN_CHANNELS_MAP[marginMode].includes(message.type)
  );
};

export const subscribeMarginsEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_MARGIN, TRADE.UPDATE_MARGIN_MODE.SUCCESS),
    filter(() => {
      const isMinimalUpdateUser = state$?.value?.user?.preferences?.minimal_updates;
      return !isMinimalUpdateUser;
    }),
    switchMap(() => {
      const marginMode = state$?.value?.user?.margin_mode;
      if (!marginMode) {
        return EMPTY;
      }
      let channel$ = EMPTY;
      if (marginMode !== MARGIN_MODE.ISOLATED) {
        channel$ = marginChannel(marginMode);
      }

      return channel$.pipe(
        takeUntil(
          action$.ofType(
            USER.LOGOUT.SUCCESS,
            UNAUTHORIZED,
            UNSUBSCRIBE_PRIVATE,
            UNSUBSCRIBE_ALL
          )
        ),
        catchError(err => {
          console.error('MARGIN CHANNEL', err);
          return EMPTY;
        })
      );
    }),

    map(message => dispatch => {
      try {
        const postActions = orderActionsMap?.[message.type];
        if (typeof postActions === 'function') {
          pipe(
            () => postActions(message, state$.value),
            Rof,
            flatten,
            forEach(dispatch)
          )();
        }
      } catch (err) {
        logToSentry(err);
      }
    })
  );

const privateChannels = () =>
  wsSubject.multiplex(
    () => ({
      type: 'subscribe',
      payload: {
        channels: privateDataChannelList(),
      },
    }),
    () => ({
      type: 'unsubscribe',
      payload: {
        channels: privateDataChannelList(),
      },
    }),
    message => contains(message.type, orderChannelNameList)
  );

export const subscribeOrdersEpic = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_ORDERS),
    filter(() => {
      const isMinimalUpdateUser = state$?.value?.user?.preferences?.minimal_updates;
      return !isMinimalUpdateUser;
    }),
    mergeMap(() => {
      return privateChannels().pipe(
        takeUntil(
          action$.ofType(
            USER.LOGOUT.SUCCESS,
            UNAUTHORIZED,
            UNSUBSCRIBE_PRIVATE,
            UNSUBSCRIBE_ALL
          )
        ),
        catchError(_ => EMPTY)
      );
    }),
    map(message => dispatch => {
      // Ideally it's supposed to go to catchError block. Not sure what the issue is. So, had to use try catch here
      try {
        const postActions = orderActionsMap[message.type];
        if (typeof postActions === 'function') {
          // postActions might return an array, hence flattening it later.
          pipe(
            () => postActions(message, state$.value),
            Rof, // [action1] || [[action2, action3]]
            flatten, // [action1, action2, action3]
            forEach(dispatch)
          )();
        }
      } catch (err) {
        logToSentry(err);
      }
    })
  );

export const disconnectSocketOnTabInactive = (action$: CustomAction) =>
  action$.pipe(
    ofType(TAB_INACTIVE),
    switchMap(() => {
      return timer(TAB_INACTIVE_DELAY).pipe(
        map(() => {
          return disconnectSocket({ retry: false });
        }),
        takeUntil(action$.ofType(DISCONNECT_SOCKET, TAB_REACTIVE))
      );
    })
  );

export const reconnectSocketOnTabReactive = (
  action$: CustomAction,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(TAB_REACTIVE),
    map(() => socketActiveSelector(state$.value)),
    filter(val => {
      return val === false || val === null;
    }), // if socket is connected no need to do anything
    mergeMap(val => {
      return isAuthenticated(state$.value.user)
        ? from([
            getProductList(),
            getSpotIndices(),
            getSettings(),
            getKycStatus(),
            getPositionsFromApi(),
            getOpenOrdersFromApi(),
            getOpenStopOrdersFromApi(),
            ...getTradePageActions(),
            ...getTransactionPageAction(),
            getConversionConfig(),
            connectSocket(),
            getOptionsInfo(),
          ])
        : from([
            getProductList(),
            getSettings(),
            connectSocket(),
            getSpotIndices(),
            getOptionsInfo(),
          ]);
    })
  );

export const logToSentry = err => {
  devOnlyErrorLogger('logToSentry', err);
  return withScope(scope => {
    scope.setExtras(err);
    captureException(err);
  });
};

export const enabledWalletSpotSymbols = () => {
  return ENABLED_WALLETS?.filter(symbol => symbol !== ASSET_SYMBOL).map(symbol =>
    symbol === 'BTC'
      ? `.DEXBT${VANILLA_SETTLING_ASSET}`
      : `.DE${symbol}${VANILLA_SETTLING_ASSET}`
  );
};

export default combineEpics(
  connectEpic,
  connectedEpic,
  verifySocketConnectionEpic,
  closeWebsocketConnectionEpic,
  initialiseSocketSubscriptionEpic,
  connectSelectedProductEpic,
  subscribeHeartbeatEpic,
  heartbeatCheck,
  publicChannelEpic,
  subscribeTickerChannelEpic,
  subscribePositionTickerChannelEpic,
  subscribeOHLCEpic,
  unsubscribeOhlcCandleEpic,
  subscribeFundingChannelEpic,
  tokenEpic,
  subscribeTradingNotificationsEpic,
  subscribeOrdersEpic,
  disconnectSocketOnTabInactive,
  reconnectSocketOnTabReactive,
  subscribeContractAllRecentTradesEpic,
  subscribeMarginsEpic
  // unsubscribeL2Orderbook,
);
